// MARK: React
import * as React from "react";
import "./style.scss";
import { observer } from "mobx-react";

// Stores
import AddressService from "../../../../../services/AddressService";

// Components
import TextField from "../../../../../components/TextField";
import MaskedTextField from "../../../../../components/MaskedTextField";

// Resources
import strings from "../../../../../resources/strings";
import GoogleMap from "../../../../../components/Maps/GoogleMap";

interface IProps {
	addressService: AddressService;
	loading: boolean;
}

@observer
export default class HotelLocationForm extends React.Component<IProps> {
	public render() {
		const { addressService, loading } = this.props;
		const canShowTheRest = !addressService.cepBeeingValidated && addressService.cepValidated;

		return (
			<>
				<h2>{strings.hotel.edit.sections.address}</h2>
				<div className="formMapWrapper">
					<div className="inputsContainer">
						<MaskedTextField
							name="cep"
							mask="99.999-999"
							label={strings.hotel.edit.fields.address.cep}
							onChange={addressService.handleValueChange}
							value={addressService.cep}
							errorMessage={addressService.cepValidationErrorMessage}
							disabled={
								loading ||
								addressService.cepBeeingValidated
							}
							onMaskComplete={(cepString) => {
								addressService.cepValidate(cepString);
							}}
						/>
						{
							canShowTheRest && (
								<>
									<TextField
										label={strings.hotel.edit.fields.address.street}
										name="street"
										value={addressService.street}
										disabled={loading}
										onChange={addressService.handleValueChange}
									/>
									<TextField
										label={strings.hotel.edit.fields.address.number}
										name="number"
										value={addressService.number}
										disabled={loading}
										onChange={addressService.handleValueChange}
									/>
									<TextField
										label={strings.hotel.edit.fields.address.neighborhood}
										name="neighborhood"
										value={addressService.neighborhood}
										disabled={loading}
										onChange={addressService.handleValueChange}
									/>
									<TextField
										label={strings.hotel.edit.fields.address.city}
										name="city"
										value={addressService.city}
										disabled={loading}
										onChange={addressService.handleValueChange}
									/>
									<TextField
										label={strings.hotel.edit.fields.address.state}
										name="state"
										value={addressService.state}
										disabled={loading}
										onChange={addressService.handleValueChange}
									/>
								</>
							)}

					</div>
					{
						canShowTheRest && (
							<GoogleMap
								width={440}
								height={440}
								lat={addressService.lat}
								lon={addressService.lng}
							/>
						)}
				</div>
			</>
		);
	}
}
